/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { question_response_columns } from "./data";
import Modal from "antd/lib/modal/Modal";

const StudentResponseModal = ({ question, students,showResponseModal,parentStateHook }) => {
    const responses = question.correct_attempts.map(student_id => {
        const student = students.filter(s => s.id === student_id)[0]
        return { student, status: true }
    }).concat(
        question.incorrect_attempts.map(student_id => {
            const student = students.filter(s => s.id === student_id)[0]
            return { student, status: false }
        })
    )
    return (<Modal
        visible={showResponseModal}
        title="Question Attempt Details"
        centered
        onOk={() => parentStateHook(false)}
        onCancel={() => parentStateHook(false)}
        okButtonProps={{ visible: false }}
        cancelButtonProps={{ visible: false }}
        footer={false}
    >
        <Table dataSource={responses} columns={question_response_columns} scroll={{y:400}} pagination={false}/>
    </Modal>)
}

export default StudentResponseModal